<app-expert-group-portal-header
  *ngIf="expertGroupPortal"
  selectedNavItem="resources"
  [expertGroupPortal]="expertGroupPortal"
></app-expert-group-portal-header>

<app-expert-group-portal-resources-tabs
  selectedTabItem="videos"
  [expertGroupPortal]="expertGroupPortal"
></app-expert-group-portal-resources-tabs>

<div class="container">
  <!-- large layout -->
  <ng-container *ngIf="videos && !loader">
    <div class="columns flex flex-wrap" *ngIf="videos.length">
      <div class="column is-12-mobile is-4-tablet" *ngFor="let video of videos">
        <app-video-card [video]="video"></app-video-card>
      </div>
    </div>
    <div class="columns flex flex-wrap" *ngIf="!videos.length">
      <div class="column is-12-mobile is-4-tablet">
        <p>No videos found.</p>
      </div>
    </div>
  </ng-container>

  <!-- Loader Videos -->
  <ng-container *ngIf="loader">
    <!--  Loader -->
    <div class="columns is-multiline">
      <div class="column is-12-mobile is-4-tablet">
        <div class="lc lc--regular">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
      <div class="column is-12-mobile is-4-tablet">
        <div class="lc lc--regular">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
      <div class="column is-12-mobile is-4-tablet">
        <div class="lc lc--regular">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
      <div class="column is-12-mobile is-4-tablet">
        <div class="lc lc--regular">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
      <div class="column is-12-mobile is-4-tablet">
        <div class="lc lc--regular">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
      <div class="column is-12-mobile is-4-tablet">
        <div class="lc lc--regular">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
      <div class="column is-12-mobile is-4-tablet">
        <div class="lc lc--regular">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
      <div class="column is-12-mobile is-4-tablet">
        <div class="lc lc--regular">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
      <div class="column is-12-mobile is-4-tablet">
        <div class="lc lc--regular">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
      <div class="column is-12-mobile is-4-tablet">
        <div class="lc lc--regular">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
      <div class="column is-12-mobile is-4-tablet">
        <div class="lc lc--regular">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
      <div class="column is-12-mobile is-4-tablet">
        <div class="lc lc--regular">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
